import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCockpit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16.25 17.14c.166 0 .324.065.441.18.118.114.184.27.184.432a.606.606 0 0 1-.184.433.633.633 0 0 1-.441.178H8.125a.634.634 0 0 1-.442-.178.605.605 0 0 1 0-.866.634.634 0 0 1 .442-.178h8.125ZM5.071 1.316c.31-.104.65-.085.945.053l2.63 1.086.038.017c.296.145.52.4.626.707a1.198 1.198 0 0 1-.077.949l-1.108 2.01 2.482 4.89h5.018c.331 0 .65.13.884.359.234.229.366.54.366.864v2.445c0 .324-.132.635-.366.864-.235.23-.553.358-.884.358H8.29c-.232 0-.46-.062-.658-.18a1.23 1.23 0 0 1-.461-.495L2.63 6.381a1.21 1.21 0 0 1 0-1.095l1.728-3.361c.147-.287.403-.505.712-.609Z" })
});
export default SvgCockpit;
